import { render, staticRenderFns } from "./AdicionalAdd.vue?vue&type=template&id=9dfbae34&"
import script from "./AdicionalAdd.vue?vue&type=script&lang=js&"
export * from "./AdicionalAdd.vue?vue&type=script&lang=js&"
import style0 from "./AdicionalAdd.vue?vue&type=style&index=0&id=9dfbae34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports